import 'reflect-metadata'

import { Type } from 'class-transformer'
import {
  ArrayNotEmpty,
  IsArray,
  IsBoolean,
  IsInt,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsPositive,
  IsString,
  Matches,
  MaxLength,
  ValidateNested,
} from 'class-validator'

import { EMAIL_REGEX, PHONE_REGEX } from '../constants/validations-regex'

export class SaveSupplierContactDto {
  @IsNumber()
  @IsOptional()
  id?: number

  @IsString()
  @IsNotEmpty()
  firstName!: string

  @IsString()
  @IsNotEmpty()
  lastName!: string

  @IsNumber()
  @IsInt()
  @IsPositive()
  @IsNotEmpty()
  languageId!: number

  @IsString()
  @IsNotEmpty()
  @Matches(PHONE_REGEX)
  phoneNumber!: string

  @IsString()
  @IsNotEmpty()
  @Matches(EMAIL_REGEX)
  emailAddress!: string
}

export class SaveSupplierDto {
  @IsNumber()
  @IsOptional()
  id?: number

  @IsString()
  @IsNotEmpty()
  @MaxLength(255)
  name!: string

  @IsString()
  @MaxLength(255)
  @IsOptional()
  certificate?: string

  @IsNumber()
  @IsPositive()
  @IsInt()
  regionId!: number

  @IsBoolean()
  @IsNotEmpty()
  active!: boolean

  @IsArray()
  @IsNumber({}, { each: true })
  @IsPositive({ each: true })
  @IsInt({ each: true })
  @ArrayNotEmpty()
  cropTypes!: number[]

  @IsArray()
  @ArrayNotEmpty()
  @ValidateNested({ each: true })
  @Type(() => SaveSupplierContactDto)
  contacts!: SaveSupplierContactDto[]
}
